module.exports = __webpack_public_path__ + "img/master.956f31bc.png";